module.exports = __webpack_public_path__ + "static/media/a20.64a31111.jpg";